 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		33: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"vendors~vsf-anywhere-checkout~vsf-checkout~vsf-giftbox~vsf-layout-shop~vsf-order~vsf-product~vsf-sch~983e4b99","2":"vsf-product-modal-custom-options","4":"vendors~vsf-base-input-decimal-number~vsf-layout-shop~vsf-microcart~vsf-product-modal~vsf-search~vsf~320a3e29","6":"vendors~leaflet","7":"vsf-modal-term-of-use","9":"vsf-layout-anywhere~vsf-layout-default~vsf-layout-minimal~vsf-layout-shop","11":"vsf-about-courier~vsf-courier-register~vsf-static","12":"vsf-base-address-autocomplete-input","14":"vsf-address-form~vsf-anywhere-checkout","15":"vsf-anywhere-checkout~vsf-insurance-purchase","16":"vsf-button-full","17":"vsf-component-pay-order-modal","18":"vsf-courier-register","19":"vsf-discounts-all~vsf-home","20":"vsf-instagram-feed","21":"vsf-layout-anywhere~vsf-layout-default","22":"vsf-order-confirmation","23":"vsf-product-gallery-carousel~vsf-product-gallery-zoom-carousel","24":"vsf-sidebar-menu","28":"dayjs-locales-en","29":"dayjs-locales-uk","30":"kz-cart-delivery-progress","31":"kz-cart-upsell","32":"lang-uk-UA-json","34":"product-recommended-products","35":"vendors~bodybuilder","36":"vendors~vsf-base-telephone-input","37":"vendors~vsf-inputmask","38":"vendors~vue-phone-number-input","39":"vsf-about-courier","40":"vsf-about-partner","41":"vsf-add-to-cart","42":"vsf-additional-footer","43":"vsf-address-card","44":"vsf-address-card-information","45":"vsf-address-form","46":"vsf-address-list","47":"vsf-address-map-modal","48":"vsf-anywhere-checkout","49":"vsf-apple-pay-button","50":"vsf-article-preloader","51":"vsf-back-to-top","52":"vsf-base-checkbox","53":"vsf-base-input","54":"vsf-base-input-decimal-number","55":"vsf-base-input-number","56":"vsf-base-telephone-input","57":"vsf-bounce-loader","58":"vsf-breadcrumbs","59":"vsf-cart-summary","60":"vsf-category","61":"vsf-checkout","62":"vsf-checkout-payment-failed","63":"vsf-checkout-success","64":"vsf-cms","65":"vsf-color-selector","66":"vsf-comment","67":"vsf-compare","68":"vsf-component-about-popup","69":"vsf-component-account-icon","70":"vsf-component-address-select","71":"vsf-component-bounce-loader","72":"vsf-component-category-seo-content","73":"vsf-component-home-head-image","74":"vsf-component-home-store","75":"vsf-component-infinite-loading","76":"vsf-component-logo","77":"vsf-component-microcart-icon","78":"vsf-component-search-partner","79":"vsf-configurator","80":"vsf-confirm-phone-modal","81":"vsf-credit-card","82":"vsf-custom-options-list","83":"vsf-cutlery-qty","84":"vsf-default-credit-card","85":"vsf-delivery-time","86":"vsf-departments","87":"vsf-discounts","88":"vsf-discounts-all","89":"vsf-error","90":"vsf-food-category-label","91":"vsf-generic-selector","92":"vsf-gift-comment","93":"vsf-giftbox","94":"vsf-google-pay-button","95":"vsf-grid-category-preloader","96":"vsf-guest-address-card","97":"vsf-head-img-banners-de_main-image-json","98":"vsf-head-img-banners-de_promoted_offers-json","99":"vsf-head-img-banners-it_main-image-json","100":"vsf-head-img-banners-it_promoted_offers-json","101":"vsf-head-img-categories-json","102":"vsf-head-img-main-image-json","103":"vsf-head-img-promoted_offers-json","104":"vsf-head-img-slider-json","105":"vsf-help-problems","106":"vsf-home","107":"vsf-images-lazy-load","108":"vsf-instructions","109":"vsf-insurance-purchase","110":"vsf-layout-anywhere","111":"vsf-layout-default","112":"vsf-layout-empty","113":"vsf-layout-minimal","114":"vsf-layout-shop","115":"vsf-microcart","116":"vsf-mini-add-to-cart","117":"vsf-mini-button-full","118":"vsf-mini-open-configurator","119":"vsf-modal","120":"vsf-modal-credit-cards-list","121":"vsf-my-account","122":"vsf-my-newsletter","123":"vsf-my-order","124":"vsf-my-orders","125":"vsf-my-password","126":"vsf-my-payment-details","127":"vsf-my-profile","128":"vsf-my-recently-viewer","129":"vsf-my-shipping-details","130":"vsf-no-product","131":"vsf-not-found","132":"vsf-order","133":"vsf-order-delivery-price","134":"vsf-order-history-select-location","135":"vsf-order-review","136":"vsf-order-skeleton","137":"vsf-order-slider","138":"vsf-order-slider-product","139":"vsf-order-slider-product-skeleton","140":"vsf-otp-verification-code-modal","141":"vsf-partner-view","142":"vsf-pay-order-modal","143":"vsf-pay-order-modal-change-methods","144":"vsf-pay-order-modal-credit-cards-list","145":"vsf-payment","146":"vsf-personal-details","147":"vsf-price","148":"vsf-product","149":"vsf-product-attribute","150":"vsf-product-category","151":"vsf-product-gallery","152":"vsf-product-gallery-carousel","153":"vsf-product-gallery-zoom-carousel","154":"vsf-product-image","155":"vsf-product-image-slider","156":"vsf-product-listing","157":"vsf-product-listing-related","158":"vsf-product-modal","159":"vsf-product-tile-slider","160":"vsf-promotion-slider","161":"vsf-recent-order-reorder","162":"vsf-reorder-list","163":"vsf-reset-password","164":"vsf-schedule","165":"vsf-search","166":"vsf-search-adapter-0","167":"vsf-search-adapter-1","168":"vsf-search-panel","169":"vsf-shipping","170":"vsf-social-login","171":"vsf-static","172":"vsf-subcategory","173":"vsf-thank-you-page","174":"vsf-validation-messages","175":"vsf-verify-phone-number-modal","176":"wishlist"}[chunkId]||chunkId) + "." + "4ca768baf3597c8e82ae" + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}

 		// chunk preloadng for javascript

 		var chunkPreloadMap = {
 			"111": [
 				4,
 				25,
 				115,
 				24
 			]
 		};

 		var chunkPreloadData = chunkPreloadMap[chunkId];
 		if(chunkPreloadData) {
 			chunkPreloadData.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					link.charset = 'utf-8';
 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "preload";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
